module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/7c1a59878d53c275ababce58c88baa19.png";